import Policies from "#/modules/policies/Policies";

export default Policies;
